(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('cancelServiceModalCtrl', ['$scope', '$rootScope', '$modalInstance', 'headerTitle', function ($scope, $rootScope, $modalInstance, headerTitle) {

    console.log('cancelServiceModalCtrl');

    $scope.showLiveChat = !$rootScope.ruiMethods.user.is.agent();

    $scope.mockData = {
      productInfo: {
        error: '',
        services: {
          internet: {
            productName: 'Internet',
            dueDate: '2015-05-04'
          },
          tv: {
            productName: 'TV',
            dueDate: '2006-05-12'
          }
        }
      }
    };

    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.headerTitle = headerTitle;

  }]);

})();
